import store from "@/store/index"
import {Message} from "element-ui";
import {eventBus} from "@/utils/helper/eventBus";
import {callerWindowState} from "@/utils/helper/caller.window.state";
import {jsonp} from '@/api/base/request';
import __config from '@/config';

const {apiEnv} = __config;

// 天润话务

export class CtiCloudHelper {
  CTILink = null;
  origin = 'tianrun';
  constructor(props) {
    this.CTILink = window.CTILink
  }
  register(registerOption) {
    this.CTILink.setup({
      webrtc: true,
      debug: false,
    }, () => {
      // 注册事件处理方法：断线重连
      this.CTILink.event("breakLine", (event) => {
        console.log('CTILink-breakLine =>', event);
        if (event.code === -1 && event.attempts >= 20) this.doLogin();
      });

      // 通话状态的回调 (座席状态)
      this.CTILink.event("status", (event) => {
        console.log('CTILink-status =>', event, {...this});
        const {state, stateAction} = event;

        if (state === '离线'){
          callerWindowState.ctiStatus = "离线";
          eventBus.$emit("hangup", {});
        } else if (state === '失效'){
          this.logOut();
        } else if (state === '空闲'){
          if (stateAction === "ringingCustomerNoAnswerOb") {
            eventBus.$emit("hangup", {})
          } else if (stateAction === "ringingNoAnswerIb") {
            eventBus.$emit("refuse", {})
          }
        } else if (state === '置忙'){
          callerWindowState.ctiStatus = "忙碌"
          if (stateAction === "ringingCustomerNoAnswerOb") {
            eventBus.$emit("hangup", {})
          } else if (stateAction === "ringingNoAnswerIb") {
            eventBus.$emit("refuse", {})
          }
        } else if (state === '呼叫中'){

        } else if (state === '通话'){
          if (stateAction === 'busyIb'){  // 呼入通话中
            eventBus.$emit("agentSipLink", { callId: event.mainUniqueId});
          } else if (stateAction === 'busyOb'){ //外呼双方通话中
          } else if (stateAction === 'busyAgentOb'){  // 外呼座席接听，呼叫客户中
          } else if (stateAction === 'hold'){ // 保持开始
            // stateShow = "保持";
          } else if (stateAction === 'unhold'){ // 保持接回
          } else if (stateAction === 'consultStart'){ // 咨询开始
          } else if (stateAction === 'consultLink'){  // 咨询成功
            // stateShow = "咨询";
          } else if (stateAction === 'busyConsult'){  // 被咨询通话中
          } else if (stateAction === 'busyTransfer'){ //被转移通话中
          } else if (stateAction === 'consultThreeway'){  //咨询三方
            // stateShow = "咨询三方";
          }
        } else if (state === '整理'){
          eventBus.$emit("hangup", {});
        }
      });

      // 监听-响铃 (弹屏)
      this.CTILink.event("ringing", (params) => {
        console.log('CTILink-ringing =>', params);
        eventBus.$emit("ringing", {params});
      });

      // 预览外呼结果
      this.CTILink.event("previewOutcall", (params) => {
        console.log('CTILink-previewOutcall =>', params);
      });

      // 预览外呼开始呼叫客户(外呼通话)
      this.CTILink.event("previewOutcallStart", (params) => {
        console.log('CTILink-previewOutcallStart =>', params);
        eventBus.$emit("phoneRingOutbound", {data: {ServNum: params.clid}});
        eventBus.$emit("ring", {
          params: {
            ...params,
            // customerId: this.currentCallCustomerId,
            jobOrderId: this.currentCallJobOrderId,
          }
        })
      });

      // 预览外呼客户响铃
      this.CTILink.event("previewOutcallRinging", (params) => {
        console.log('CTILink-previewOutcallRinging =>', params);
      });

      // 预览外呼双方接通
      this.CTILink.event("previewOutcallBridge", (event) => {
        console.log('CTILink-previewOutcallBridge =>', event);
        // 用户接通
        if (event.stateAction === 'busyOb') eventBus.$emit("onPreviewOutcallBridgeBusyOb", event);
        eventBus.$emit("callAnswer", {})
      });

      // // 咨询开始
      // this.CTILink.event("consultStart", (params) => {
      //   console.log('CTILink-consultStart =>', params);
      // });
      // // 咨询接听
      // this.CTILink.event("consultLink", (params) => {
      //   console.log('CTILink-consultLink =>', params);
      // });
      // // 咨询接回/挂断/取消
      // this.CTILink.event("unconsult", (params) => {
      //   console.log('CTILink-unconsult =>', params);
      // });
      // // 咨询失败
      // this.CTILink.event("consultError", (params) => {
      //   console.log('CTILink-consultError =>', params);
      // });

      // 自动登录
      this.doLogin();
    })
  }

  // 登录
  doLogin() {
    const _that = this;
    const lusUserCti = store.state.global.lusUserCti;

    // 调用座席登录权限验证接口获取sessionKey, qids和webSocketUrl等参数
    const HOSTS = apiEnv !== 'prod' ? "https://api-test-2.cticloud.cn" : "https://api-1.cticloud.cn";
    let url = `${HOSTS}/interface/v10/agentLogin/authenticateJsonp`;
    // url += `?validateType=2&enterpriseId=${lusUserCti.enterpriseId}&cno=${lusUserCti.cno}&timestamp=${lusUserCti.timestamp}&sign=${lusUserCti.sign}`;

    jsonp({
      url,
      jsonp: 'callback',
      data: {
        validateType: 2,
        enterpriseId: lusUserCti.enterpriseId,
        cno: lusUserCti.cno,
        timestamp: lusUserCti.timestamp,
        sign: lusUserCti.sign,
      }
    }).then(res => {
      const data = eval("("+res+")");
      console.log('doLogin-jsonp =>', data);
      if (data !== undefined && data.result === 0) {
        const params = {};
        params.sessionKey = data.sessionKey;
        params.enterpriseId = data.enterpriseId;
        params.cno = data.cno;
        params.bindTel = data.cno;
        params.bindType = 3;
        params.loginStatus = 1;
        params.webSocketUrl = data.agentGateWayUrl;
        params.qids = data.qids;    // 班长席时返回

        _that.CTILink.Agent.login(params, (result) => {
          console.log('坐席登录 =>', result);
          if (result.code === "0") {  // 座席登录成功
            callerWindowState.ctiStatus = result.loginStatus === 1 ? "在线" : "忙碌";

            const storeCtiStatus = sessionStorage.getItem('__store_ctiStatus');
            if (storeCtiStatus){
              if (storeCtiStatus !== 'unpause'){
                if (storeCtiStatus === 'pause') ; callerWindowState.ctiStatus = '忙碌'; 
                if (storeCtiStatus === 'logOut') ; callerWindowState.ctiStatus = '离线'; 
                this[storeCtiStatus] && this[storeCtiStatus]();
              }
            } else {
              if (lusUserCti.roleLevel > 1) this.pause();
            }
          } else {
            callerWindowState.ctiStatus = `座席登录失败，失败原因： + ${result.msg}`;
          }
        });
      } else {
        callerWindowState.ctiStatus = data.description;
        // Message.error(data.description);
      }
    }).catch(() => {
      // 登录失败，接口请求错误
    })
  }

  // 坐席外呼，坐席人员主动发起外呼。坐席状态只有在空闲、忙碌状态下才能进行外呼。
  makeCall(phoneNumber, params={}) {
    console.log('makeCall2 =>', phoneNumber, params);
    const {lusUserCti} = store.state.global;

    // this.currentCallCustomerId = params.customerId;
    this.currentCallJobOrderId = params.jobOrderId; //工单ID
    callerWindowState.currentCallCustomerRealName = params.name;

    if (this.CTILink === undefined) {
      Message.error("呼叫系统尚未初始化完成");
      eventBus.$emit("fail", {callId: params.callId, errMsg: "呼叫系统尚未初始化完成"});
    } else {
      const payload = {tel: phoneNumber, cno: lusUserCti.cno};
      console.log('autoClidOutCall-payload =>', {...payload});

      this.CTILink.Agent.autoClidOutCall(payload, (res) => {
        console.log('autoClidOutCall-res =>', res);
        if (res.code !== "0") {
          Message.error(res.msg);
          eventBus.$emit("fail", { callId: params.callId, errMsg: res.msg, ...params });
        }
      });
    }
  }
  // 坐席操作、挂断
  hangup() {
    console.log('调用 CTILink-unlink');
    eventBus.$emit("hangup", {})
    this.CTILink.Session.unlink();
  }
  // 坐席操作、呼入接听
  sipLink() {
    console.log('调用 CTILink-sipLink');
    this.CTILink.SipSession.sipLink();
  }
  // 坐席操作、呼入拒接
  refuse() {
    console.log('调用 CTILink-refuse');
    this.CTILink.Session.refuse();
  }
  // 坐席操作、置忙
  pause() {
    // console.log('调用 CTILink-pause');
    this.CTILink.Agent.pause({pauseType: 1, pauseDescription: "普通"});
    callerWindowState.ctiStatus = "忙碌";
  }
  // 坐席操作、置闲
  unpause() {
    // console.log('调用 CTILink-unpause');
    if (callerWindowState.ctiStatus === "忙碌") {
        this.CTILink.Agent.unpause();
        callerWindowState.ctiStatus = "在线";
    } else {
        this.doLogin()
    }
  }
  // 坐席操作、保持
  holdCall() {
    console.log('调用 CTILink-holdCall');
    this.CTILink.Session.hold();
    callerWindowState.muting = true;
  }
  // 坐席操作、取消保持
  unHold() {
    console.log('调用 CTILink-unHold');
    this.CTILink.Session.unhold();
    callerWindowState.muting = false;
  }
  /**
   * 坐席操作、开启自动外呼
   */
  startAutoDial() {
    eventBus.$emit("startAutoDial", {})
  }
  /**
   * 坐席操作、关闭自动外呼
   */
  closeAutoDial() {
    eventBus.$emit("closeAutoDial", {})
  }
  // 坐席操作、坐席下班
  logOut(callback) {
    // console.log('调用 CTILink-logOut');
    this.CTILink.Agent.logout({logoutMode: 1, removeBinding: 0}, callback);
  }
}



// window.$.ajax({
//   type: "GET",
//   dataType:"jsonp",
//   jsonp:"callback",
//   url,
//   success: (r) => {
//     console.log(r);
//     const data = eval("("+r+")");
//     if (data !== undefined && data.result === 0) {
//       const params = {};
//       params.sessionKey = data.sessionKey;
//       params.enterpriseId = data.enterpriseId;  //
//       params.cno = data.cno;
//       params.bindTel = data.cno;
//       params.bindType = 3;
//       params.loginStatus = 1;
//       params.webSocketUrl = data.agentGateWayUrl;
//       params.qids = data.qids;    // 班长席时返回

//       _that.CTILink.Agent.login(params, (result) => {
//           if (result.code === "0") {
//               callerWindowState.ctiStatus = result.loginStatus === 1 ? "在线" : "忙碌"
//               // 座席登录成功
//           } else {
//               callerWindowState.ctiStatus = `座席登录失败，失败原因： + ${result.msg}`
//               // 座席登录失败，失败原因： + result.msg
//           }
//       });
//     } else {
//       callerWindowState.ctiStatus = data.description
//     }
//   },
//   error: (r) =>  {
//       // 登录失败，接口请求错误
//   }
// });
